<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" :style="headerStyle">
      <div class="md-layout">
        <div class="md-layout-item">
          <div class="image-wrapper">
            <div class="brand">
              <h1>{{ title }}</h1>
              <!-- <h3>Let's play together.</h3> -->
            </div>
          </div>
        </div>
      </div>
    </parallax>

    <div class="main main-raised">
      <div class="section profile-content">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 mx-auto">
              <div class="profile">
                <div class="avatar">
                  <img
                    :src="img"
                    alt="Circle Image"
                    class="img-raised rounded-circle img-fluid" />
                </div>
                <div class="name">
                  <h3 class="title">Carla Hortensia</h3>
                  <h6>Designer</h6>
                  <md-button
                    href="javascript:void(0)"
                    class="md-just-icon md-simple md-dribbble"
                    ><i class="fab fa-dribbble"></i
                  ></md-button>
                  <md-button
                    @click="showNotificationError('接收不到來自Line的認證碼')"
                    class="md-just-icon md-simple md-twitter"
                    ><i class="fab fa-twitter"></i
                  ></md-button>
                  <md-button
                    href="javascript:void(0)"
                    class="md-just-icon md-simple md-pinterest"
                    ><i class="fab fa-pinterest"></i
                  ></md-button>
                </div>
              </div>
            </div>
          </div>
          <div class="description text-center">
            <p>
              An artist of considerable range, Chet Faker — the name taken by
              Melbourne-raised, Brooklyn-based Nick Murphy — writes, performs
              and records all of his own music, giving it a warm, intimate feel
              with a solid groove structure.
            </p>
          </div>
          <!-- <div class="profile-tabs">
            <tabs
              :tab-name="['Studio', 'Work', 'Favorite']"
              :tab-icon="['camera', 'palette', 'favorite']"
              plain
              nav-pills-icons
              color-button="success"
            >
              <template slot="tab-pane-1">
                <div class="md-layout">
                  <div class="md-layout-item md-size-25 ml-auto">
                    <img :src="tabPane1[0].image" class="rounded" />
                    <img :src="tabPane1[1].image" class="rounded" />
                  </div>
                  <div class="md-layout-item md-size-25 mr-auto">
                    <img :src="tabPane1[3].image" class="rounded" />
                    <img :src="tabPane1[2].image" class="rounded" />
                  </div>
                </div>
              </template>
              <template slot="tab-pane-2">
                <div class="md-layout">
                  <div class="md-layout-item md-size-25 ml-auto">
                    <img :src="tabPane2[0].image" class="rounded" />
                    <img :src="tabPane2[1].image" class="rounded" />
                    <img :src="tabPane2[2].image" class="rounded" />
                  </div>
                  <div class="md-layout-item md-size-25 mr-auto">
                    <img :src="tabPane2[3].image" class="rounded" />
                    <img :src="tabPane2[4].image" class="rounded" />
                  </div>
                </div>
              </template>
              <template slot="tab-pane-3">
                <div class="md-layout">
                  <div class="md-layout-item md-size-25 ml-auto">
                    <img :src="tabPane3[0].image" class="rounded" />
                    <img :src="tabPane3[1].image" class="rounded" />
                  </div>
                  <div class="md-layout-item md-size-25 mr-auto">
                    <img :src="tabPane3[2].image" class="rounded" />
                    <img :src="tabPane3[3].image" class="rounded" />
                    <img :src="tabPane3[4].image" class="rounded" />
                  </div>
                </div>
              </template>
            </tabs>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
// import { Tabs } from "@/components"
const jwt = require('jsonwebtoken')
const axios = require('axios').default

export default {
  components: {
    // Tabs
  },
  name: "lineCallback",
  bodyClass: "line-callback-page",
  data() {
    return {
      tabPane1: [
        { image: require("@/assets/img/examples/studio-1.jpg") },
        { image: require("@/assets/img/examples/studio-2.jpg") },
        { image: require("@/assets/img/examples/studio-4.jpg") },
        { image: require("@/assets/img/examples/studio-5.jpg") }
      ],
      tabPane2: [
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/cynthia-del-rio.jpg") },
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/clem-onojegaw.jpg") }
      ],
      tabPane3: [
        { image: require("@/assets/img/examples/mariya-georgieva.jpg") },
        { image: require("@/assets/img/examples/studio-3.jpg") },
        { image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
        { image: require("@/assets/img/examples/olu-eletu.jpg") },
        { image: require("@/assets/img/examples/studio-1.jpg") }
      ]
    };
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/skate.jpg")
    },
    title: {
      type: String,
      default: "Welcome"
    },
    img: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  mounted() {

    let code = this.$route.query.code
    let state = this.$route.query.state
    if (!code || !state) {
      setTimeout(() => { this.showNotificationError('接收不到來自Line的狀態碼') }, 500)
      setTimeout(() => { this.$router.push({ name: 'index' }) }, 3000)
    } else {

      let stateLocal = localStorage.getItem(Vue.Constants.KEY_LS_LINE_STATE)

      let nonceString = localStorage.getItem(Vue.Constants.KEY_LS_LINE_NONCE)
      var nonce = null 
      if (nonceString) {
        nonce = JSON.parse(nonceString)
      }

      if (state !== stateLocal) {
        this.showNotificationError('狀態碼不正確')
        setTimeout(() => { this.$router.push({ name: 'index' }) }, 3000)
        return
      }

      const params = new URLSearchParams()
      params.append('grant_type', 'authorization_code')
      params.append('code', code)
      params.append('redirect_uri', Vue.Constants.LINE_REDIRECT_URL)
      params.append('client_id', Vue.Constants.LINE_CLIENT_ID)
      params.append('client_secret', Vue.Constants.LINE_SECRET)
      let vm = this
      axios.post('https://api.line.me/oauth2/v2.1/token', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function (response) {

        let accessToken = response.data.access_token
        let idToken = response.data.id_token
        let refreshToken = response.data.refresh_token

        vm.$store.commit('setRefreshToken', refreshToken)
        vm.$store.commit('setAccessToken', accessToken)

        // vm.verify(idToken, (parsedToken) => {
        //   if (parsedToken) {
        //     vm.showNotificationSuccess('Hi! ' + parsedToken.name + ', 你已成功登入。')
        //   } else {
        //     vm.showNotificationError('unknown issue')
        //   }
        // })

        let headers = {}
        headers[Vue.Constants.BADMINTON_API_HEADER_AUTH] = 'Bearer ' + accessToken
        headers[Vue.Constants.BADMINTON_API_HEADER_ID_TYPE] = Vue.Constants.ID_TYPE_LINE
        axios.get(Vue.Constants.BADMINTON_API_URL + 'users/profile', {headers: headers}).then(function (response) {

          vm.$store.commit('setUser', response.data.data.user)
          vm.showNotificationSuccess('Hi! ' + vm.$store.state.user.name + ', 你已成功登入。')
          setTimeout(() => { vm.$router.push({ name: 'index' }) }, 3000)
        }).catch(function (error) {
          vm.showNotificationError(error)
          setTimeout(() => { vm.$router.push({ name: 'index' }) }, 3000)
        })
      }).catch(function (error) {
        vm.showNotificationError(error)
        setTimeout(() => { vm.$router.push({ name: 'index' }) }, 3000)
      })
    }
  },
  methods: {
  //   verify(token, onIdTokenParsed) {
  //     jwt.verify(token, Vue.Constants.LINE_SECRET, { audience: Vue.Constants.LINE_CLIENT_ID, issuer: 'https://access.line.me' }, function(err, decoded) {
  //       if (err) {
  //         onIdTokenParsed(null)
  //       } else {
  //         onIdTokenParsed(decoded)
  //       }
  //     })
  //   }
  }
}
</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
</style>
